import(/* webpackMode: "eager", webpackExports: ["AnfrageClient"] */ "/vercel/path0/src/app/anfrage/anfrage-client.tsx");
